<div class="dashboard-content" style="padding: 120px 40px 50px">
  <div class="billing-and-payments-screen">
    <div class="page-heading">
      <h3>{{ 'activity-logs.title' | translate }}</h3>
      <div class="heading-right">
        <div class="search">
          <input type="text" class="form-control" [placeholder]="'activity-logs.search-placeholder' | translate" [(ngModel)]="searchTerm"
            (input)="onSearchChange()" autocapitalize="off" style="text-transform: none;">
          <i class="fa-solid fa-magnifying-glass" style="cursor: pointer;"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="searchTerm" (click)="searchTerm = ''; onSearchChange()"
            style="cursor: pointer;"></i>
        </div>
        <button class="btn btn-light filter-btn" (click)="exportCsv()">
          <i class="fa-solid fa-file-csv"></i>
          <span>{{ 'common.export' | translate }} CSV</span>
        </button>
      </div>
    </div>

    <!-- Filters Row -->
    <div class="filters-row">
      <div class="filter-item">
        <label>{{ 'activity-logs.category' | translate }}</label>
        <nz-select [(ngModel)]="selectedCategory" (ngModelChange)="onFilterChange()"
          [nzPlaceHolder]="'activity-logs.all-categories' | translate" nzAllowClear style="width: 100%;">
          <nz-option *ngFor="let opt of categoryOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
        </nz-select>
      </div>
      <div class="filter-item">
        <label>{{ 'activity-logs.action' | translate }}</label>
        <nz-select [(ngModel)]="selectedAction" (ngModelChange)="onFilterChange()"
          [nzPlaceHolder]="'activity-logs.all-actions' | translate" nzAllowClear style="width: 100%;">
          <nz-option *ngFor="let opt of actionOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
        </nz-select>
      </div>
      <div class="filter-item">
        <label>{{ 'activity-logs.severity' | translate }}</label>
        <nz-select [(ngModel)]="selectedSeverity" (ngModelChange)="onFilterChange()"
          [nzPlaceHolder]="'activity-logs.all-severities' | translate" nzAllowClear style="width: 100%;">
          <nz-option *ngFor="let opt of severityOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
        </nz-select>
      </div>
      <div class="filter-item">
        <label>{{ 'activity-logs.date-from' | translate }}</label>
        <nz-date-picker class="custom-select" [(ngModel)]="dateFrom" (ngModelChange)="onFilterChange()"
          [nzPlaceHolder]="'activity-logs.select-date' | translate" nzFormat="dd/MM/yyyy"></nz-date-picker>
      </div>
      <div class="filter-item">
        <label>{{ 'activity-logs.date-to' | translate }}</label>
        <nz-date-picker class="custom-select" [(ngModel)]="dateTo" (ngModelChange)="onFilterChange()"
          [nzPlaceHolder]="'activity-logs.select-date' | translate" nzFormat="dd/MM/yyyy"></nz-date-picker>
      </div>
    </div>

    <!-- Logs Table -->
    <div class="luqta-card">
      <div class="card-heading">
        <h3>{{ 'activity-logs.title' | translate }} ({{ totalLogs }})</h3>
      </div>

      <nz-table #logsTable [nzData]="logs" [nzBordered]="true" [nzScroll]="{ x: '1400px' }"
        [nzFrontPagination]="false" [nzPageSize]="perPage" [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]" [nzShowPagination]="true" [nzPageIndex]="currentPage"
        [nzTotal]="totalLogs" (nzPageSizeChange)="onPageSizeChange($event)"
        (nzPageIndexChange)="onPageIndexChange($event)">
        <thead>
          <tr>
            <th nzWidth="50px">#</th>
            <th nzWidth="180px">{{ 'activity-logs.date-time' | translate }}</th>
            <th nzWidth="140px">{{ 'activity-logs.category' | translate }}</th>
            <th nzWidth="120px">{{ 'activity-logs.action' | translate }}</th>
            <th nzWidth="110px">{{ 'activity-logs.severity' | translate }}</th>
            <th nzWidth="300px">{{ 'activity-logs.description' | translate }}</th>
            <th nzWidth="180px">{{ 'activity-logs.content' | translate }}</th>
            <th nzWidth="80px" nzRight>{{ 'activity-logs.details' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of logsTable.data; let i = index">
            <td>{{ (currentPage - 1) * perPage + i + 1 }}</td>
            <td>{{ formatDateTime(log.created_at) }}</td>
            <td>
              <span class="category-badge" [ngClass]="getCategoryClass(log.category)">
                {{ (log.category || '-').replace('_', ' ') }}
              </span>
            </td>
            <td>
              <span class="action-text">{{ log.action || '-' }}</span>
            </td>
            <td>
              <span class="severity-badge" [ngClass]="getSeverityClass(log.severity)">
                {{ log.severity || '-' }}
              </span>
            </td>
            <td>
              <span [title]="log.description">
                {{ (log.description || '').length > 60 ? (log.description | slice:0:60) + '...' : log.description || '-' }}
              </span>
            </td>
            <td>
              <span [title]="log.content_title">
                {{ log.content_type ? log.content_type + ': ' : '' }}{{ log.content_title || '-' }}
              </span>
            </td>
            <td nzRight>
              <svg (click)="openDetailDrawer(log)" width="18" height="18" viewBox="0 0 18 18" fill="none"
                xmlns="http://www.w3.org/2000/svg" nz-tooltip [nzTooltipTitle]="'activity-logs.view-details' | translate"
                style="cursor: pointer;">
                <mask id="mask0_activity_log" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"
                  style="mask-type: alpha;">
                  <rect width="17.7778" height="17.7778" fill="#D9D9D9"></rect>
                </mask>
                <g mask="url(#mask0_activity_log)">
                  <path
                    d="M8.89034 11.8518C9.81626 11.8518 10.6033 11.5277 11.2514 10.8796C11.8996 10.2314 12.2237 9.44437 12.2237 8.51845C12.2237 7.59252 11.8996 6.80548 11.2514 6.15734C10.6033 5.50919 9.81626 5.18511 8.89034 5.18511C7.96441 5.18511 7.17737 5.50919 6.52922 6.15734C5.88108 6.80548 5.557 7.59252 5.557 8.51845C5.557 9.44437 5.88108 10.2314 6.52922 10.8796C7.17737 11.5277 7.96441 11.8518 8.89034 11.8518ZM8.89034 10.5184C8.33478 10.5184 7.86256 10.324 7.47367 9.93511C7.08478 9.54622 6.89034 9.074 6.89034 8.51845C6.89034 7.96289 7.08478 7.49067 7.47367 7.10178C7.86256 6.71289 8.33478 6.51845 8.89034 6.51845C9.44589 6.51845 9.91811 6.71289 10.307 7.10178C10.6959 7.49067 10.8903 7.96289 10.8903 8.51845C10.8903 9.074 10.6959 9.54622 10.307 9.93511C9.91811 10.324 9.44589 10.5184 8.89034 10.5184ZM8.89034 14.074C7.08787 14.074 5.44589 13.5709 3.96441 12.5647C2.48293 11.5586 1.40885 10.2098 0.742188 8.51845C1.40885 6.82709 2.48293 5.47832 3.96441 4.47215C5.44589 3.46598 7.08787 2.96289 8.89034 2.96289C10.6928 2.96289 12.3348 3.46598 13.8163 4.47215C15.2977 5.47832 16.3718 6.82709 17.0385 8.51845C16.3718 10.2098 15.2977 11.5586 13.8163 12.5647C12.3348 13.5709 10.6928 14.074 8.89034 14.074ZM8.89034 12.5925C10.2854 12.5925 11.5663 12.2252 12.7329 11.4907C13.8996 10.7561 14.7916 9.76536 15.4089 8.51845C14.7916 7.27153 13.8996 6.28079 12.7329 5.54622C11.5663 4.81166 10.2854 4.44437 8.89034 4.44437C7.49527 4.44437 6.21441 4.81166 5.04774 5.54622C3.88108 6.28079 2.9891 7.27153 2.37182 8.51845C2.9891 9.76536 3.88108 10.7561 5.04774 11.4907C6.21441 12.2252 7.49527 12.5925 8.89034 12.5925Z"
                    fill="#1C1B1F"></path>
                </g>
              </svg>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>

<!-- Detail Drawer -->
<ng-template #logDetailTitle>
  <div class="drawer-title">
    <i class="fa-solid fa-file-lines"></i>
    {{ 'activity-logs.log-details' | translate }}
  </div>
</ng-template>
<nz-drawer [nzVisible]="drawerVisible" [nzClosable]="true" [nzWidth]="540" nzPlacement="right"
  [nzTitle]="logDetailTitle" (nzOnClose)="closeDrawer()">
  <ng-container *nzDrawerContent>
    <div class="log-detail-content" *ngIf="selectedLog">

      <!-- Summary Card -->
      <div class="detail-summary-card">
        <div class="summary-header">
          <span class="category-badge" [ngClass]="getCategoryClass(selectedLog.category)">
            {{ (selectedLog.category || '-').replace('_', ' ') }}
          </span>
          <span class="severity-badge" [ngClass]="getSeverityClass(selectedLog.severity)">
            {{ selectedLog.severity }}
          </span>
          <span class="action-badge">{{ selectedLog.action }}</span>
        </div>
        <p class="summary-description">{{ selectedLog.description || '-' }}</p>
        <div class="summary-time">
          <i class="fa-regular fa-clock"></i>
          {{ formatDateTime(selectedLog.created_at) }}
        </div>
      </div>

      <!-- User Information -->
      <div class="detail-card">
        <div class="detail-card-header">
          <i class="fa-regular fa-user"></i>
          <h4>{{ 'activity-logs.user-info' | translate }}</h4>
        </div>
        <div class="detail-card-body">
          <div class="detail-item">
            <span class="detail-label">{{ 'activity-logs.user-name' | translate }}</span>
            <span class="detail-value">{{ selectedLog.user_name || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ 'activity-logs.user-email' | translate }}</span>
            <span class="detail-value">{{ selectedLog.user_email || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ 'activity-logs.user-role' | translate }}</span>
            <span class="detail-value">{{ (selectedLog.user_role || '-').replace('_', ' ') }}</span>
          </div>
        </div>
      </div>

      <!-- Content Information -->
      <div class="detail-card" *ngIf="selectedLog.content_type || selectedLog.content_title">
        <div class="detail-card-header">
          <i class="fa-regular fa-file"></i>
          <h4>{{ 'activity-logs.content-info' | translate }}</h4>
        </div>
        <div class="detail-card-body">
          <div class="detail-item" *ngIf="selectedLog.content_type">
            <span class="detail-label">{{ 'activity-logs.content-type' | translate }}</span>
            <span class="detail-value">{{ selectedLog.content_type }}</span>
          </div>
          <div class="detail-item" *ngIf="selectedLog.content_title">
            <span class="detail-label">{{ 'activity-logs.content-title' | translate }}</span>
            <span class="detail-value">{{ selectedLog.content_title }}</span>
          </div>
        </div>
      </div>

      <!-- Changes -->
      <div class="detail-card" *ngIf="changesList.length > 0">
        <div class="detail-card-header">
          <i class="fa-solid fa-code-compare"></i>
          <h4>{{ 'activity-logs.changes' | translate }}</h4>
        </div>
        <div class="detail-card-body no-padding">
          <div class="changes-table">
            <div class="changes-header">
              <span>{{ 'activity-logs.field' | translate }}</span>
              <span>{{ 'activity-logs.old-value' | translate }}</span>
              <span>{{ 'activity-logs.new-value' | translate }}</span>
            </div>
            <div class="changes-row" *ngFor="let change of changesList">
              <span class="change-field">{{ change.field }}</span>
              <span class="change-old">{{ change.old_value }}</span>
              <span class="change-new">{{ change.new_value }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </ng-container>
</nz-drawer>
